<tec-modal
	[isVisible]="true"
	[title]="detail ? ('API_KEYS.FORM.EDIT' | translate) : ('API_KEYS.FORM.CREATE' | translate)"
	[tagImage]="modalTagImage"
	[buttonPrimaryLabel]="primaryButtonLabel"
	[buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
	(closeEvent)="closeModal($event)">
	<ng-container body [formGroup]="form">
        @if (errorMsg) {
            <tec-alert
                status="error"
                [msg]="errorMsg"
                (closeAlert)="errorMsg = ''"
            ></tec-alert>
        }
        <div class="grid grid-i2">
            <tec-form-group [label]="('API_KEYS.FORM.NAME' | translate) + '*'"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('alias'))">
                <tec-input formControlName="alias"
                    [hasError]="reactiveFormService.hasError(form.get('alias'))"
                ></tec-input>
            </tec-form-group>
            @if (detail) {
            <tec-form-group
                [label]="('API_KEYS.FORM.CODE' | translate) + '*'"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('key'))"
            >
                <tec-input formControlName="key" [hasError]="reactiveFormService.hasError(form.get('key'))" />
            </tec-form-group>
            }
            @if (companyOptions.length > 1) {
                <tec-form-group [label]="('API_KEYS.FORM.COMPANY' | translate) + '*'"
                    [errorMsg]="reactiveFormService.hasMsgError(form.get('company_uuid'))">
                    <tec-select formControlName="company_uuid"
                        [options]="companyOptions"
                        [search]="true"
                        [hasError]="reactiveFormService.hasError(form.get('company_uuid'))"
                        [placeholder]="'API_KEYS.FORM.COMPANY_PLACEHOLDER' | translate"
                    ></tec-select>
                </tec-form-group>
            }
        </div>
    </ng-container>
</tec-modal>
